import { render, staticRenderFns } from "./Logar.vue?vue&type=template&id=6330e042"
import script from "./Logar.vue?vue&type=script&lang=ts"
export * from "./Logar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports